<template>
  <div class="joinus-container">
    <div class="item-background"></div>
    <div class="item-container">
      <div class="left">
        <div class="title-line">诚聘人工智能和机器学习等方向教师、研究人员</div>
        <div class="content">
          <span class="red-tag">研究方向：</span> <br />●
          知识图谱构建、管理、查询、表示学习等相关领域； <br />●
          深度学习、自然语言处理等相关领域； <br />●
          图计算等相关领域； <br />●
          向量检索、近似最近邻搜索等相关领域； <br />●
          异构网络社区查询、查询发现等相关领域； <br />●
          AIGC、多模态学习等相关领域； <br />● <span class="red-tag"
            >应聘要求：</span
          >
          <br />● 近年内在国内外获得博士学位； <br />●
          在上述相关研究领域有扎实的学术成果和研究经验； <br /><span
            class="red-tag"
            >待遇福利：</span
          >
          <br />● 参照杭州电子科技大学工作待遇执行；[工作待遇] <br />●
          实验室可参照相关政策文件及项目情况给予额外奖励； <br />●
          实验室提供必需的实验与办公条件； <br /><span class="red-tag"
            >申请材料：</span
          >
          <br />● 个人简历（含学历、工作经历、主要研究方向、研究成果等）；
          <br />● 简历所述信息的相关证明材料； <br /><span class="red-tag"
            >申请方式：</span
          >
          <br />● 请将申请材料发至邮箱；xxl@hdu.edu.cn or lsswyx@hdu.edu.cn
        </div>
        <div class="title-line">欢迎优秀本科生、研究生加入实验室</div>
        <div class="content">
          <span class="red-tag">报考硕士、博士研究生：</span>
          <br />● 欢迎品行良好、自律性强、主动学习、乐于分享的同学； <br />●
          至少熟练掌握C、C++、Java、Python中的两种语言，具有良好的代码能力；
          <br />● 熟悉Linux/Unix系统及相关常用软件； <br />●
          具备良好的中文表达沟通能力、具备良好的英语读写听说能力； <br />●
          发送邮件并随附：个人简历、教务系统成绩、考研成绩、研究兴趣与计划；
          <br />● 博士生导师： <br />&nbsp;&nbsp;&nbsp;&nbsp;○ 徐小良教授
          xxl@hdu.edu.cn <br />● 硕士生导师： <br />&nbsp;&nbsp;&nbsp;&nbsp;○
          徐小良 xxl@hdu.edu.cn <br />&nbsp;&nbsp;&nbsp;&nbsp;○ 王宇翔
          lsswyx@hdu.edu.cn <br /><span class="red-tag">本科毕设：</span>
          <br />● 毕设题目不限于实验室已有研究方向，师生可充分讨论确定； <br />●
          发送邮件并随附：个人简历、教务系统成绩、毕设内容意向； <br />●
          毕设导师： <br />&nbsp;&nbsp;&nbsp;&nbsp;○ 徐小良 xxl@hdu.edu.cn
          <br />&nbsp;&nbsp;&nbsp;&nbsp;○ 王宇翔 lsswyx@hdu.edu.cn
          <br />&nbsp;&nbsp;&nbsp;&nbsp;○ 方启明 fangqiming@hdu.du.cn
          <br />&nbsp;&nbsp;&nbsp;&nbsp;○ 夏一行 yixingx@hdu.edu.cn <br /><span
            class="red-tag"
            >走进实验室：</span
          >
          <br />● 欢迎各年级优秀学生加入实验室，参与实验室相关科研项目； <br />●
          发送邮件并随附：个人简历、教务系统成绩单；
        </div>
      </div>

      <div class="right">
        <div class="img-box">
          <img
            class="right-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/join1.jpeg"
            alt=""
          />
          <div class="img-desc">成员合照1</div>
        </div>
        <div class="img-box">
          <img
            class="right-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/join2.jpeg"
            alt=""
          />
          <div class="img-desc">成员合照2</div>
        </div>
        <div class="img-box">
          <img
            class="right-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/join3.jpeg"
            alt=""
          />
          <div class="img-desc">实验室——杭电第一教学楼</div>
        </div>
        <div class="img-box">
          <img
            class="right-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/join4.jpeg"
            alt=""
          />
          <div class="img-desc">实验室——杭电第四教学楼</div>
        </div>
        <div class="img-box">
          <img
            class="right-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/join5.jpeg"
            alt=""
          />
          <div class="img-desc">会议室</div>
        </div>
        <div class="img-box">
          <img
            class="right-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/join6.jpeg"
            alt=""
          />
          <div class="img-desc">之江实验室</div>
        </div>
        <div class="img-box">
          <img
            class="right-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/join7.png"
            alt=""
          />
          <div class="img-desc">之江实验室办公区</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.joinus-container {
  min-height: 100vh;
}
.item-background {
  height: 60px;
}
.item-container {
  width: 80%;
  margin: 0px auto;
  display: flex;
}
.title-line {
  margin-top: 80px;
  margin-bottom: 32px;
  font-family: Microsoft YaHei;
  font-size: 40px;
  font-weight: 300;
  color: #333;
}
.left {
  width: 70%;
  padding: 16px;
  padding-left: 0;
}
.right {
  width: 30%;
  padding: 16px;
  padding-right: 0;
}
.img-box {
  width: 100%;
}
.right-img {
  width: 100%;
}
.img-desc {
  font-weight: bold;
  text-align: center;
  margin-top: 4px;
  margin-bottom: 20px;
}
.content {
  font-size: 20px;
  color: #444;
  line-height: 36px;
  /* font-weight: bold; */
}
.red-tag {
  font-weight: bold;
  display: inline-block;
  margin-top: 12px;
  margin-bottom: 8px;
}
@media screen and (max-width: 900px) {
  .item-container {
    display: block;
    width: 93%;
  }
  .left {
    width: 100%;
  }
  .right {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/joinus/index.vue